import { ref } from 'vue';
import { defineStore, storeToRefs } from 'pinia';
import { getV8DashboardsGotoDashboardList } from '@/api-client/metav8Over/queries/integrated-dashboard-v8-controller/integrated-dashboard-v8-controller';
import type { DashboardItem } from '@/api-client/dashboard/model';
import { FRAME_NAMES } from '@/common/define/apiTrace.define';
import { useViewModeStore } from '@/common/stores/view-mode';
import { MAXGAUGE_MODE_FILTER_LIST } from '@/common/components/organisms/setupDashBoardPopup/setupDashBoardPopup.define';

export const useDashboardJumpStore = defineStore('dashboardJump', () => {
  const { isMaxgaugeMode } = storeToRefs(useViewModeStore());
  const dashboardJumpList = ref<DashboardItem[]>([]); // 대시보드 점프 팝업에서 사용.

  const fetchDashboardJumpList = async () => {
    try {
      const {
        data: { data = [] },
      } = await getV8DashboardsGotoDashboardList({
        params: { frameName: FRAME_NAMES.DASHBOARD.DASHBOARD_LIST_POPUP },
      });

      if (isMaxgaugeMode.value) {
        dashboardJumpList.value = (data ?? []).filter(
          (v) => v.iconId === null || MAXGAUGE_MODE_FILTER_LIST.includes(v.iconId!),
        );
      } else {
        dashboardJumpList.value = data ?? [];
      }
    } catch (e) {
      console.log(e);
    }
  };

  return {
    dashboardJumpList,

    fetchDashboardJumpList,
  };
});
